import { Divider } from "primereact/divider";
import React from "react";
import CopyDataComponent from "components/copyData";
import "./index.css"

function ViewDataComponent(props) {
  return (
    <>
      <div className="row main-div view-data-row">
        <div className="col left-view-column-data">
          <label>{props.label}</label>
        </div>
        <div className="col right-view-column-data">
          <p className={props.class}>
            {" "}
            {isNumeric(props.data) ? "Rs " : ""}
            {isNumeric(props.data)
              ? props.data.toLocaleString()
              : props.data}{" "}
          </p>
          {props.isShown ? <CopyDataComponent data={props.data} /> : ""}
        </div>
      </div>
      <Divider className="view-divider" />
    </>
  );
}

function isNumeric(something) {
  return typeof something === "number";
}

export default ViewDataComponent;
